import React, { useEffect, useState } from "react"
import { Col, Modal } from "react-bootstrap"
import ProjectDTO from "./ProjectDTO"
import CRUDField from "../core/genericCRUD/CRUDField"
import FieldSelector from "../core/FieldSelector"
import { useTranslation } from "react-i18next"
import { useFormik } from "formik"
import * as yup from "yup"
import yupTypeValidator from "../../common/YupTypeValidator"
import API from "../../common/API"
import { parsedUser } from "../../common/GetCurrentUser"
import { toast } from "react-toastify"
import CRUD from "../core/genericCRUD/CRUD"
import ProjectBuildingDTO from "./ProjectBuildingDTO"
import AddEditProjectEmployee from "./AddEditProjectEmployee"
import { confirmAlert } from "react-confirm-alert"

const AddEdit = props => {
  // PROPERTIES
  const [record, setRecord] = useState<any>(null)
  const buildingFields: CRUDField[] = ProjectBuildingDTO
  const fields: CRUDField[] = ProjectDTO
  const { t } = useTranslation("global")
  const [formikInitialObject, setFormikInitialObject] = useState<any>({})
  const [validationsSchema, setValidationSchema] =
    useState<yup.ObjectSchema<any>>()
  const [isLoading, setIsLoading] = useState(false)
  const user = parsedUser()
  const formik = useFormik({
    initialValues: formikInitialObject,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: validationsSchema,
    onSubmit: () => handleSubmit(),
  })
  type YupSchema =
    | yup.StringSchema
    | yup.BooleanSchema
    | yup.NumberSchema
    | yup.DateSchema
  // METHODS

  const fillFormikObject = (record: any) => {
    fields.forEach((item: CRUDField) => {
      if (item && item.name.length > 0) {
        //console.log("field name", item.name, "RecordValue ", record[item.name]);
        if (record && record[item.name]) {
          formik.setFieldValue(item.name, record[item.name])
        }
      }
    })
  }

  const prepareFormikObject = () => {
    const initialObject: { [key: string]: string } = {}
    const initialObjectValidation: { [key: string]: YupSchema } = {}

    if (fields) {
      fields.forEach((item: CRUDField) => {
        // if (item.FieldName === "Id" || item.FieldName === "File") return;

        initialObject[item.name] = item.value

        if (item.required) {
          const schema = yupTypeValidator(item)
          if (schema) {
            initialObjectValidation[item.name] = schema
          }
        }
      })
    }

    // formik.initialValues = initialObject;
    setFormikInitialObject(initialObject)
    setValidationSchema(yup.object().shape(initialObjectValidation))
  }

  const updateField = (fieldName: string, fieldValue: any) => {
    //console.log(fieldName, fieldValue)
    formik.setFieldValue(fieldName, fieldValue)
  }

  const selectMapSearch = async (value: any) => {
    formik.setFieldValue("latitude", value.geometry.location.lat)
    formik.setFieldValue("longitude", value.geometry.location.lng)
    formik.setFieldValue("locationMap", {
      lat: value.geometry.location.lat,
      lng: value.geometry.location.lng,
    })
  }

  const handleSubmit = async () => {
    try {
      console.log("values to submit", formik.values)

      let query = {}
      fields.forEach((item: CRUDField) => {
        if (item && item.htmlType !== "separator" && item.name.length > 0) {
          query[item.name] = formik.values[item.name] ?? null
        }
      })

      query["locationMap"] = undefined
      query["organizationId"] = user.OrganizationId
      console.log(query)
      setIsLoading(true)
      let request = (await API.postAction(`projects/AddEdit`, query)) as any
      if (request.data.status === "ok") {
        toast.success(t("record saved"))
        props.toggle()
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }

  const bindDataRemote = async () => {
    try {
      if (record === null) return
      console.log("bind data remote", record)
      setIsLoading(true)
      let request = await API.getAction("projects/Details?id=" + record.id)
      if (request.data.status === "ok") {
        fillFormikObject(request.data.response)

        formik.setFieldValue("locationMap", {
          lat: request.data.response.latitude,
          lng: request.data.response.longitude,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  // EVENTS
  useEffect(() => {
    prepareFormikObject()
  }, [])

  useEffect(() => {
    setRecord(props.record)
  }, [props.record])

  useEffect(() => {
    console.log("load remote content")
    bindDataRemote()
  }, [record])

  const [showAddEditProjectEmployee, setShowAddEditProjectEmployee] =
    useState<boolean>(false)
  const toggleAddEditProjectEmployee = () => {
    setShowAddEditProjectEmployee(!showAddEditProjectEmployee)
    if (showAddEditProjectEmployee) {
      bindEmployee()
    }
  }
  const [employees, setEmployees] = useState<any[]>([])
  const bindEmployee = async () => {
    try {
      const request = await API.getAction(
        "projects/getEmployees?projectId=" + formik.values.id
      )
      if (request.data.status === "ok") {
        setEmployees(request.data.response)
      }
    } catch (ex) {
      console.error(ex)
    }
  }
  const removeEmployee = async (item: any) => {
    if (item) {
      confirmAlert({
        closeOnClickOutside: false,
        message: t("Are you sure you want to delete this record?") ?? "",
        buttons: [
          {
            label: t("Yes"),
            onClick: async () => {
              await API.getAction("projects/RemoveEmployee?id=" + item.id)
              setEmployees(
                employees.filter((record: any) => record.id !== item.id)
              )
            },
          },
          {
            label: "No",
            onClick: () => {
              console.log("no")
            },
          },
        ],
      })
    }
  }
  useEffect(() => {
    if (formik.values.id) {
      bindEmployee()
    }
  }, [formik.values.id])

  return (
    <>
      {showAddEditProjectEmployee && (
        <AddEditProjectEmployee
          parent={formik.values}
          toggle={toggleAddEditProjectEmployee}
        />
      )}
      <Modal
        show={true}
        onHide={props.toggle}
        size={props.modalSize ? props.modalSize : "lg"}
        className={props.cssClass + " modalRight"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Destino Laboral")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex gap-2 flex-col px-4">
            <div className="row">
              {fields &&
                fields
                  .filter(x => x.htmlType !== "hidden" && x.groupNumber === 0)
                  .map((item, index) => {
                    return (
                      <FieldSelector
                        key={index}
                        model={{
                          ...item,
                          readOnly: props.readOnly ?? false,
                        }}
                        updateField={updateField}
                        selectMapSearch={selectMapSearch}
                        obj={formik.values}
                        value={
                          formik.values[item.name as keyof typeof formik.values]
                        }
                        errors={formik.errors}
                      />
                    )
                  })}
              {/* Sub sections  */}
              {formik.values.id && (
                <Col xs={12} className="my-4">
                  <CRUD
                    fields={buildingFields}
                    isModal={false}
                    // modalSize="sm"
                    cssClass="modalRight"
                    filterOpen={false}
                    readOnly={props.readOnly}
                    // showModal={props.show}
                    // toggleCRUD={props.toggle}
                    title={t("Espacio Laboral") ?? ""}
                    icon={"fas fa-building"}
                    parentId="projectId"
                    parentValue={formik.values.id}
                    getRecordsMethod="post"
                    getRecordsPath={`projectBuilding/list`}
                    addEditRecordPath={`projectBuilding/AddEdit`}
                    deleteRecordPath="projectBuilding/Delete"
                    fieldsList={[
                      {
                        name: "name",
                        title: t("Name"),
                        htmlType: "text",
                      },
                      {
                        name: "projectBuildingTypeName",
                        title: t("Type"),
                        htmlType: "text",
                      },
                    ]}
                  />
                </Col>
              )}

              {formik.values.id && (
                <Col xs={12} className="my-4">
                  <h3>
                    {t("Employees and Contractors") ?? ""}
                    <button
                      className="btn btn-sm ms-2 btn-primary"
                      onClick={() => {
                        toggleAddEditProjectEmployee()
                      }}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </h3>
                  <hr />
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>{t("Name")}</th>
                        <th>{t("Last Name")}</th>
                        <th>{t("Employment Type")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {employees &&
                        employees.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.firstName}</td>
                              <td>{item.lastName}</td>
                              <td>{item.employeeType}</td>
                              <td className="text-end">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {
                                    removeEmployee(item)
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                </Col>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {!props.readOnly && (
            <div className="modal-action m-0 p-2 ">
              {isLoading && (
                <div className="me-4 d-inline-block">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
              <button
                className="btn btn-secondary me-2"
                disabled={isLoading}
                onClick={() => props.toggle()}
                type="button"
              >
                {t("Cancel")}
              </button>

              <button
                className="btn btn-primary text-white"
                disabled={isLoading}
                onClick={() => formik.submitForm()}
                type="button"
              >
                {t("Save")}
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default AddEdit
